<template>
  <AppDialog
      v-model="dialog"
      title="Audit Log"
      max-width="1100px"
      scrollable
      @close="dialog = false"
  >
    <v-card-text>
      <v-row class="pt-4" dense>
        <v-col cols="12" sm="3">
          <v-select
              v-model="entityType"
              :items="entityTypeItems"
              label="Entity type"
              density="compact"
              hide-details
              @update:model-value="reload"
          />
        </v-col>
        <v-col cols="12" sm="5">
          <v-text-field
              v-model="entityLabel"
              label="Whale id or sighting number"
              density="compact"
              clearable
              hide-details
              @keyup.enter="reload"
              @click:clear="onClearLabel"
          />
        </v-col>
        <v-col cols="6" sm="2">
          <v-select
              v-model="limit"
              :items="limitItems"
              label="Show"
              density="compact"
              hide-details
              @update:model-value="reload"
          />
        </v-col>
        <v-col cols="6" sm="2" class="d-flex align-center">
          <v-btn
              color="primary"
              block
              :loading="loading"
              prepend-icon="mdi-refresh"
              @click="reload"
          >
            Refresh
          </v-btn>
        </v-col>
      </v-row>

      <audit-log-panel
          :entries="entries"
          :loading="loading"
          empty-text="No audit entries match these filters."
      />
    </v-card-text>
    <v-card-actions>
      <v-spacer />
      <v-btn @click="dialog = false">
        <v-icon>mdi-close</v-icon>
        Close
      </v-btn>
    </v-card-actions>
  </AppDialog>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import AppDialog from "@/components/AppDialog";
import AuditLogPanel from "@/components/audit/AuditLogPanel.vue";

export default {
  name: "AuditLogDialog",
  components: {
    AppDialog,
    AuditLogPanel,
  },
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["update:modelValue"],
  data() {
    return {
      entityType: null,
      entityLabel: null,
      limit: 200,
      entityTypeItems: [
        { title: "All", value: null },
        { title: "Whales", value: "whale" },
        { title: "Sightings", value: "sighting" },
      ],
      limitItems: [
        { title: "50", value: 50 },
        { title: "100", value: 100 },
        { title: "200", value: 200 },
        { title: "All", value: -1 },
      ],
    };
  },
  computed: {
    ...mapGetters({
      entries: "audit/entries",
      loading: "audit/loading",
    }),
    dialog: {
      get() {
        return this.modelValue;
      },
      set(value) {
        this.$emit("update:modelValue", value);
      },
    },
  },
  watch: {
    modelValue(open) {
      if (open) {
        this.reload();
      }
    },
  },
  methods: {
    ...mapActions({
      loadEntries: "audit/loadEntries",
    }),
    reload() {
      this.loadEntries({
        entityType: this.entityType,
        entityLabel: this.entityLabel || null,
        limit: this.limit,
      });
    },
    onClearLabel() {
      this.entityLabel = null;
      this.reload();
    },
  },
};
</script>
